@let info = myInfo();
@let stats = unavailableStats();

<div class="mySettings" [style.display]="ui.settingsOpen() ? 'block' : 'none'">
  <h2 class="heading"><span translate="itgen_gmr_user_settings"></span><span class="closeSettings" (click)="ui.closeSettings()"></span></h2>
  <div class="userSettingsContent">
    <div class="settingsUser">
      <img class="userSettingImage" src="images/user-icon.svg" />
      <div class="settingsUserContainer">
        <span>{{ info?.usr_name }}</span>
        <span>{{ info?.usr_company_name }}</span>
        <a [href]="'mailto:' + info?.usr_email_address">{{ info?.usr_email_address }}</a>
      </div>
      <div class="userLanguageWrapper">
        <span class="licenseText" [title]="info?.usr_license_text_hint" [style.color]="info?.usr_license_text_color">{{ info?.usr_license_text_contents }}</span>
        <div class="nodeWrapper">
          <span class="userLang">{{ info?.usr_language }}</span>
        </div>
      </div>
    </div>
    <div class="statsContainer">
      <h3 translate="itgen_gmr_statistics" class="statsListH3"></h3>
      <ul class="statsList">
        <li><span class="statLabel" translate="itgen_gmr_data_container_id"></span><span class="stat">{{ info?.data_container_id }}</span></li>
      </ul>
      <h3 translate="itgen_gmr_api_statistics" class="statsListH3"></h3>
      <ul class="statsList">
        <li>
          <span class="statLabel" translate="itgen_gmr_api_call_limits"></span>
          <span class="stat">{{ info?.daily_limit_min }}
            @if (showApiCallLimits())
            {
              <span class="apiCallLimits"> ... {{ info?.daily_limit_max }}</span>
            }
          </span>
        </li>
        <li>
          <span class="statLabel" translate="itgen_gmr_api_remaining_calls"></span>
          <span class="stat">{{ info?.daily_remaining_min }}
            @if (showApiRemainingCalls())
            {
              <span class="apiRemainingCalls"> ... {{ info?.daily_remaining_max }}</span>
            }
          </span>
        </li>
        <li><span class="statLabel" translate="itgen_gmr_api_top_users"></span><span class="stat">{{ info?.low_scorers }}</span></li>
      </ul>
      <h3 translate="itgen_gmr_unavailable_statistics" class="statsListH3"></h3>
      <ul class="statsList">
        <li [class.unavailableAlert]="unavailableAlert().inactive">
          <span class="statLabel" translate="itgen_gmr_unavailable_inactive"></span>
          <span class="stat reasonStat">
            {{ stats?.inactive_cnt !== null && stats?.inactive_cnt !== 0 ? stats?.inactive_cnt : ('itgen_gmr_inactive_cnt_none' | translate) }}
          </span>
          @if (stats?.inactive_list != undefined)
          {
            <span class="customLabel reasonLabel">{{ stats?.inactive_list }}</span>
          }
        </li>
        <li [class.unavailableAlert]="unavailableAlert().outsideServiceArea">
          <span class="statLabel" translate="itgen_gmr_unavailable_osa"></span>
          <span class="stat reasonStat">
            {{ stats?.outside_service_area_cnt !== null && stats?.outside_service_area_cnt !== 0 ? stats?.outside_service_area_cnt : ('itgen_gmr_outside_cnt_none' | translate) }}
          </span>
          @if (stats?.outside_service_area_list != undefined)
          {
            <span class="unavailableList reasonLabel">{{ stats?.outside_service_area_list }}</span>
          }
        </li>
        <li [class.unavailableAlert]="unavailableAlert().compliance">
          <span class="statLabel" translate="itgen_gmr_unavailable_compliance"></span>
          <span class="stat reasonStat">
            {{ stats?.compliance_cnt !== null && stats?.compliance_cnt !== 0 ? stats?.compliance_cnt : ('itgen_gmr_compliance_cnt_none' | translate) }}
          </span>
          @if (stats?.compliance_list != undefined)
          {
            <span class="customLabel reasonLabel">{{ stats?.compliance_list }}</span>
          }
          @if ((stats?.compliance_cnt ?? 0) > 0)
          {
            <a class="complianceButton" [href]="complianceUrl" target="_blank" rel="noopener"
               [title]="'itgen_gmr_compliance_more_info' | translate"
               translate="itgen_gmr_compliance_more_info_button"></a>
          }
        </li>
        <li [class.unavailableAlert]="unavailableAlert().unknown">
          <span class="statLabel" translate="itgen_gmr_unavailable_unknown"></span>
          <span class="stat reasonStat">
            {{ stats?.unknown_cnt !== null && stats?.unknown_cnt !== 0 ? stats?.unknown_cnt : ('itgen_gmr_unknown_cnt_none' | translate) }}
          </span>
          @if (stats?.unknown_list != undefined)
          {
            <span class="customLabel reasonLabel">{{ stats?.unknown_list }}</span>
          }
        </li>
      </ul>
    </div>
  </div>
</div>
